export default {
  datepicker: {
    width: '100%',
    maxWidth: 440,
  },
};
